var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.ABOUT.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("프라이빗 세일(Private Sales)이란?")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "page-text word-keep-all"
  }, [_c('p', [_vm._v("우리는 일반적으로 공개 경매의 경쟁 설정을 권장하지만 경우에 따라 비공개 매매 (프라이빗 세일)가 더 적절합니다. 일부 개체의 경우 특히 적절한 구매자(박물관 또는 특히 동기가 부여된 수집가)가 한 명 있을 수 있습니다. 때때로 판매자의 상황은 판매를 위한 짧은 시간 프레임 또는 개인 판매의 재량을 요구할 수도 있습니다.")]), _c('p', {
    staticClass: "mt-10 mt-md-14"
  }, [_vm._v("시장과 그 시장을 주도하는 수집가, 기관 및 딜러에 대한 우리의 지식을 통해 우리는 적절한 구매자에게 훌륭한 물건을 매칭할 수 있습니다. 개인 판매(일반적으로 $50,000 이상 가치)에는 더 중요한 물건만 고려됩니다. 개인 판매에 대한 우리의 수수료는 작품의 가치와 성격에 따라 다릅니다.")])]), _c('v-divider', {
    staticClass: "my-20 my-md-24"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8"
    }
  }, [_c('p', {
    staticClass: "page-text primary--text"
  }, [_vm._v("개인적으로 판매하고 싶은 중요한 품목이 있는 경우, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("측면 버튼을 클릭하여 저희에게 연락하십시오.")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "color": "primary",
      "to": "/form/consignment-sale"
    }
  }, [_vm._v("문의하기")])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "mt-30 mt-lg-50"
  }, [_c('v-img', {
    staticClass: "img-wide",
    attrs: {
      "cover": "",
      "src": "/images/sub/private/private-define-img.png"
    }
  })], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-30"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("Private Sales")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h3', {
    staticClass: "tit tit--sm line-height-14"
  }, [_vm._v("당사는 공개 경쟁을 통한 경매를 권장하지만, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("경우에 따라 비공개 매매(프라이빗 세일)가 더 적절합니다")])])], 1)], 1), _c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-define-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("비공개 매매")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("프라이빗 세일은 특정작품 혹은 특별한 작품을, 경매를 통하지 않고, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("비공개적 방법으로 매매합니다.")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-define-img3.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("높은 보안성")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("고정된 가격과 편안한 일정으로 매매하며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("보안성이 매우 높은 거래방식입니다.")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-define-img4.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("매개를 통한 1 : 1 거래방식")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("당사를 매개로 개인과 개인간에 이루어지는 사적(私的)인 거래방식이며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("특별하고 독특한 예술 작품을, 신중하고 내밀(內密)하게 매매할 수 있는 방식입니다.")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-define-img5.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("판매자 구매자 모두를 만족")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("위탁 고객의 요구사항, 가격, 일정 등을 존중하며, 개별화된 접근방식으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("잠재구매자와 접촉하여, 쌍방 고객에게 최상의 대안을 제시합니다.")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])])], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-40"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("참여 방법")])]), _c('div', {
    staticClass: "my-n10 my-md-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "56",
      "height": "56",
      "src": "/images/sub/private/private-define-icon.png"
    }
  })], 1), _c('div', [_c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("작품정보 확인")]), _c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("우선, 작가명, 작품명, 연도, 크기, 재질 등의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("작품정보를 확인합니다.")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "56",
      "height": "56",
      "src": "/images/sub/private/private-define-icon2.png"
    }
  })], 1), _c('div', [_c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("참고자료 전달")]), _c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("기타 작품과 관련된 사진 및 참고자료가 있으면 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("제공해 주십시요.")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "64",
      "height": "56",
      "src": "/images/sub/private/private-define-icon3.png"
    }
  })], 1), _c('div', [_c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("KICI 연락")]), _c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("당사로 전화 혹은 이메일로 연락을 주십시오 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("문의사항에 대하여 친절하고 상세하게 안내해 드리겠습니다.")])], 1)])])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }